import { useCallback } from "react";
import axios from "axios";
import { v4 as uuidv4 } from 'uuid';

const globalUrlGraphQL ='/data-api/graphql';

const useFetchGraphQL = () => {

  const fetchRates = useCallback(async () => {
    const rateOptions = ["hour", "hday", "day", "week", "month"];

    try {
      const promises = rateOptions.map(rateOption => {
        const query = {
          query: `query {
            rate_by_pk(id: "${rateOption}") {
              id
              Rate
              TaxValue
              TotalAmount
              TotalPrice
              Type
            }
          }`
        };

        return axios.post(globalUrlGraphQL, query, {
          headers: { "Content-Type": "application/json" }
        }).then(res => res.data.data.rate_by_pk);
      });

      const fetchedRates = await Promise.all(promises);
      return fetchedRates;

    } catch (error) {
      console.error(error);
      throw error;
    }
  }, []);

  const fetchSpots = useCallback(async (date, resourceId) => {
    const query = {
      query: `query {
        spots(filter: { Date: { eq: "${date}" }${resourceId ? `, ResourceId: { eq: "${resourceId}" }` : ''} }) {
          items { Date ResourceId Time }
        }
      }`,
      variables: {}
    };

    const config = {
      method: 'post',
      url: globalUrlGraphQL,
      headers: { 'Content-Type': 'application/json' },
      data: JSON.stringify(query)
    };

    const response = await axios(config);
    return response;
  }, []);

  const createContact = async ({ email, name, body, subject, subjectId, language  }) => {
    try {
      const data = JSON.stringify({
        query: `mutation {
          createcontact(item: {
            Email: "${email}",
            Name: "${name}",
            id: "${uuidv4()}",
            Message: "${body}",
            Subject: "${subject}",
            SubjectId: "${subjectId}",
            Language: "${language}"
          }) {
            Email
            Name
            id
            Message
            Subject
            SubjectId
            Language
          }
        }`
      });

      const config = {
        method: 'post',
        url: globalUrlGraphQL,
        maxBodyLength: Infinity,
        headers: { 'Content-Type': 'application/json' },
        data: data,
      };

      const response = await axios.request(config);
      return response;
    } catch (error) {
      console.error(error);
      return false;
    }
  };

  const fetchBookingByPk = async (bookingCode, email) => {
    try {
      const data = JSON.stringify({
        query: `query query {
          booking_by_pk(id: "${bookingCode}_${email}") {
            AccessCode
            AmountPaid
            BookingCode
            CheckoutId
            Email
            EndDate
            EndTime
            id
            Name
            StartDate
            StartTime
            Status
            ResourceId
            Type
            Extras
          }
        }`,
        variables: {}
      });
  
      const config = {
        method: 'post',
        maxBodyLength: Infinity,
        data: data,
        url: globalUrlGraphQL,
        headers: { 'Content-Type': 'application/json' }
      };
  
      const response = await axios(config);
      return response;
    } catch (error) {
      console.error(error);
      throw error;
    }
  };

  const fetchVoucherByPk = async (voucherId) => {
    try {
      const data = JSON.stringify({
        query: `query query {
          voucher_by_pk(id: "${voucherId}") {
            id
            Email
            Available
            BonoCount
            ExpiryDateTime
            CreatedDateTime
          }
        }`,
        variables: {}
      });
  
      const config = {
        method: 'post',
        maxBodyLength: Infinity,
        data: data,
        url: globalUrlGraphQL,
        headers: { 'Content-Type': 'application/json' }
      };
  
      const response = await axios(config);
      return response;
    } catch (error) {
      console.error(error);
      throw error;
    }
  };

  return {
    fetchRates,
    fetchSpots,
    createContact,
    fetchBookingByPk,
    fetchVoucherByPk
  };
};

export default useFetchGraphQL;
